<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import DontExist from "@/components/company/components/DontExist"
import evidenciaProfesiogramaAPI from "../../../services/standards/evidenciaProfesiograma/evidenciaProfesiogramaAPI";
import perfilesCargoAPI from "../../../services/standards/perfilesCargo/perfilesCargoAPI";
import EvidenciaProfesiogramaPagination from "../../../components/standard/evidenciaProfesiograma/EvidenciaProfesiogramaPagination.vue";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Perfiles de cargo - profesiograma",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    DontExist,
    EvidenciaProfesiogramaPagination
  },
  data() {

    return {
      title: "3.1.3 Perfiles de cargo - profesiograma",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Perfiles de cargo - profesiograma",
        },
        {
          text: "Evidencia comunicación profesiograma",
          active: true,
        },
      ],

      colaboradorProveedor: [],
      types: [],
      lista: [],
      loading: true,
      loading2: true,
      acta: null,
      profesiograma: null,

      itemData: null,

      item: null,

      search: "",

      itemData: null,

      file: null,
      lastId: 1,
      perfil: {
        date: null,
        supplier: null,
        observations: null,
        evidence: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

    };
  },

  validations: {

    file: {
      required,
    },

    perfil: {

      date: {
        required,
      },
      supplier: {
        required,
      },

    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(25)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 25)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.3/${this.lastId}/evidencia/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.3/${this.lastId}/evidencia/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.perfil.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getType() {
      perfilesCargoAPI.getTypes()
        .then((response) => {
          this.loading = false
          let types = response.data;
          this.types = types
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    async save() {
      this.submitted = true
      this.loading = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let response = await this.uploadDocument();
        if (response) {
          evidenciaProfesiogramaAPI.save(this.perfil)
            .then((resp) => {
              this.sendNotification(57, 25, true);
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Se ha registrado con éxito!",
                  text: "¡Se ha registrado con éxito!",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000)
            })
            .catch((error) => {
              console.log(error);
              this.loading = false
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡No se ha podido registrar, error de documento!",
              text: "¡No se ha podido registrar, error de documento!",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
        }
      }
    },

    deleteEvaluacion(id) {
      evidenciaProfesiogramaAPI.delete(id)
        .then((data) => {
          Swal.fire({
            title: "Se ha sido eliminado con exito!",
            text: "Se ha sido eliminado con exito!",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      evidenciaProfesiogramaAPI.getAll(this.companyID)
        .then((response) => {
          let identificacion = response.data.data;
          this.lista = identificacion
          this.loading = false
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems();
    this.getList();
    this.getItemData();
    this.getType();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Pendiente
                    </p>
                  </CheckModal>
                </div>

              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-4 px-2" label="Seleccionar Fecha" label-for="trainingDate">
                    <b-form-input type="date" id="trainingDate" v-model="perfil.date"
                      :class="{ 'is-invalid': $v.perfil.date.$error && submitted }">
                    </b-form-input>
                    <div v-if="submitted && $v.perfil.date.$error">
                      <small v-if="!$v.perfil.date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>

                  </b-form-group>

                  <b-form-group class="col-md-4 px-2 mb-3" label="Proveedor evaluaciones médicas" label-for="file">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="text" id="date_exam"
                      v-model="perfil.supplier" :class="{ 'is-invalid': $v.perfil.supplier.$error && submitted }"
                      maxlength="50">
                    </b-form-input>
                    <div v-if="submitted && $v.perfil.supplier.$error">
                      <small v-if="!$v.perfil.supplier.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Evidencia de la comunicación" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                    <div v-if="submitted && $v.file.$error">
                      <small v-if="!$v.file.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="trainingDate"
                      v-model="perfil.observations" maxlength="100">
                    </b-form-textarea>

                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">

                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha</th>
                              <th class="text-center align-middle">Proveedor de evaluaciones médicas</th>
                              <th class="align-middle">Observaciones</th>
                              <th class="text-center align-middle">Evidencia</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.date) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.supplier }}
                              </td>

                              <td class=" align-middle">
                                {{ dato.observations }}
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.evidence === null">
                                  <h6>No hay archivo disponible
                                  </h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()"
                                    style=" background-color: transparent !important; border: none;" type="button"
                                    @click="gotoDigitalOcean(`${dato.evidence
                                      }`)"> <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/evidencia-profesiograma-ver/${dato.id}` }">
                                      Ver</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>
                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">Advertencia</h4>
                                        <p class="mt-3">
                                          Al modificar esta información se quitará el puntaje correspondiente
                                          a este ítem y será necesario realizar nuevamente la validación por
                                          parte del usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()" type="button"
                                          class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white"
                                            :to="{ path: `/forms/estandares/evidencia-profesiograma-editar/${dato.id}` }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="$bvModal.hide(`modal${dato.id}`)"
                                          class="btn btn-danger btn mx-2" data-dismiss="modal">Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteEvaluacion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                        <EvidenciaProfesiogramaPagination ref="paginator" :search="search" @fetch="(items) => (lista = items)" />

                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else-if="!loading && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>